angular.module('jobSearchModule', ['angulartics', 'angulartics.google.tagmanager', 'ui.bootstrap', 'cacheManagerModule',
    'rememberModule', 'ttcmExtensionsModule', 'geoHelperModule'])
    .service('lookupService', ['$q', 'cacheManagerService', lookupService])
    .service('jobSearchService', ['$q', 'cacheManagerService', 'geoHelperFactory', jobSearchService])
    .service('shareWidgetService', ['$q', 'cacheManagerService', shareWidgetService])
    .service('layoutService', ['$q', '$modal', 'cacheManagerService', layoutService])
    .service('signInService', ['$q', 'geoHelperFactory', 'cacheManagerService', signInService])
    .controller('signInModalController', ['$scope', '$sce', '$modalInstance', 'signInService', 'rememberFactory', 'ttcmExtensionsService', signInModalController])
    .controller('viewListingModalController', ['$scope', '$modalInstance', '$timeout', 'layoutService', 'params', viewListingModalController])
    .controller('shareDialogController', ['$scope', '$modalInstance', 'shareWidgetService', 'canonicalURL', shareDialogController])
    .controller('jobSearchController', ['$q', '$scope', '$modal', '$timeout', '$window', 'lookupService', 'jobSearchService',
        'rememberFactory', jobSearchController]
        ).directive('onEnter', function () {
            return function (scope, element, attrs) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.onEnter);
                        });

                        event.preventDefault();
                    }
                });
            };
        });